import { styled } from "@mui/material";
import Mui5 from "components/mui5";

export const MonitoringSelectorButton = styled(Mui5.Button)({
  justifyContent: "flex-start",
});
